module.exports = __webpack_public_path__ + "img/muletto.a0d62814.png";